(function employeeFileDetailControllerDefinition() {

    'use strict';

    angular.module('EmployeeFile')
        .controller('EmployeeFileDetailController', [
            '$scope', '$state', '$filter', '$window', '$translate', '$stateParams', 'errorsExtend', 'documentContainerService', 'authExtend', 'processService', 'configViewService', 'containerTypeService', 'adminContainerTypeService', 'certificateService', 'profileCertificateService',
            function employeeFileDetailController($scope, $state, $filter, $window, $translate, $stateParams, errors, documentContainerService, authExtend, processService, configViewService, containerTypeService, adminContainerTypeService, certificateService, profileCertificateService) {

                $scope.metadataNotEmpty = false;
                $scope.UserId = authExtend.getUserId();
                $scope.certificateProcessType = {};
                $scope.canAddCertificate = authExtend.isInRole('CERTIFICATE START');
                $scope.edit = function () {
                    $state.go('employee-file-edit', { id: $stateParams.id });
                };

                $scope.cancel = function () {
                    $window.history.back();
                };

                $scope.loadCertificateProviders = function () {
                    certificateService.getProviders(0, authExtend.getOrganizationId()).then(function (result) {
                        $scope.certificateProviders = result;
                    });
                };

                $scope.requestCertificate = function (provider) {
                    $scope.existingCertificate = undefined;
                    provider = provider || $scope.certificateProviders[0];
                    switch (provider.id) {
                        case 1: //encode
                            return $scope.beginWorkFlow();
                        case 2: //nacion
                        case 3: //lakaut
                            return $scope.checkExistingCertificate(provider).then($scope.saveCertificate);
                        default:
                    }
                };

                $scope.load = function () {
                    $scope.data = {
                        currentPage: 1,
                        totalItems: 0,
                        itemsPerPage: 15,
                        from: 0,
                        showNoData: false
                    };

                    $translate(['PaginationNext', 'PaginationPrev', 'PaginationLast', 'PaginationFirst'])
                        .then(function (translated) {
                            $scope.paginatorTranslations = {
                                nextText: translated.PaginationNext,
                                previousText: translated.PaginationPrev,
                                lastText: translated.PaginationLast,
                                firstText: translated.PaginationFirst
                            };
                        });

                    $scope.employeeFile = null;
                    $scope.cuilSystemName = '_cuil';
                    $scope.userIdSystemName = '_userId';
                    $scope.userId = authExtend.getUserId();
                    $scope.documentId = $stateParams.docId;

                    $scope.options = {
                        toggleWrap: function (scope) {
                            var collapsed = scope.$nodeScope.collapsed = !scope.$nodeScope.collapsed;
                            if (!collapsed & !scope.hasChild()) {

                                documentContainerService.getTreeOf(scope.$nodeScope.$modelValue.id).then(function (result) {
                                    if (result.length > 0) {
                                        scope.$nodeScope.$modelValue.childs = result[0].childs;
                                    }
                                });
                            }
                        }
                    };

                    $scope.loadCertificateProviders();

                    return $scope.loadConfigView()
                        .then($scope.loadContainerType)
                        .then($scope.loadDocumentContainer);
                };

                $scope.loadConfigView = function () {
                    return configViewService.getById('CPPCertificateRRHH').then(function (result) {
                        if (result && result.processTypes.length > 0) {
                            $scope.certificateProcessType = result.processTypes[0];
                        }
                    }, function (error) {
                        errors.showError(error);
                        $scope.cancel();
                    });
                };

                $scope.loadContainerType = function () {
                    return adminContainerTypeService.getMetadataMappings(authExtend.getOrganizationRoot()).then(function (result) {
                        for (var i = 0; i < result.length; i++) {
                            if (result[i].sourceMetadataMapping.length > 0 && result[i].targetMetadataMapping.length > 0) {
                                $scope.containerType = result[i];
                            }
                        }
                        if ($scope.containerType) {
                            // Valido que tenga permisos para el tc
                            containerTypeService.isContainertypeInRole(['EMPLOYEEFILE READ', 'EMPLOYEEFILE WRITE', 'EMPLOYEEFILE ADM'], $scope.containerType.id).then(function (r) {
                                if (!r) {
                                    errors.showError('EDRTC');
                                    $scope.cancel();
                                }
                            }, function (error) {
                                errors.showError(error);
                                $scope.cancel();
                            });

                            $scope.containerType.targetMetadataMapping.forEach(function (item, index) {
                                if (item.metadataSystemName === $scope.cuilSystemName) {
                                    $scope.cuilSystemName = $scope.containerType.sourceMetadataMapping[index].metadataSystemName;
                                }
                                if (item.metadataSystemName === $scope.userIdSystemName) {
                                    $scope.userIdSystemName = $scope.containerType.sourceMetadataMapping[index].metadataSystemName;
                                }
                            });
                        }
                    });
                };

                $scope.loadDocumentContainer = function () {
                    return documentContainerService.getTreeOf($stateParams.id).then(function (result) {
                        if (result.length > 0) {
                            $scope.employeeFile = result[0];

                            containerTypeService.getById($scope.employeeFile.containerTypeId).then(function (result) {
                                $scope.employeeFile.metadatas = $scope.employeeFile.metadatas.filter(function (item) {
                                    return result.metadata.some(function (ctm) {
                                        return ctm.metadataSystemName === item.metadataSystemName;
                                    });
                                });

                                $scope.employeeFile.metadatas.sort(function (a, b) {
                                    return a.position - b.position;
                                });

                                $scope.tree = result;
                                $scope.metadataNotEmpty = $scope.employeeFile.metadatas.length > 0;
                            }, function (error) {
                                errors.showError(error);
                                $scope.cancel();
                            });
                        } else {
                            $scope.tree = {};
                            errors.show('NotFound');
                            $scope.cancel();
                        }
                    }, function (error) {
                        errors.showError(error);
                        $scope.cancel();
                    });
                };

                $scope.edit = function () {
                    $state.go('employee-file-edit', { id: $scope.employeeFile.id });
                };

                $scope.beginWorkFlow = function () {
                    var params = {
                        processTypeId: $scope.certificateProcessType.processTypeId,
                        processTypeName: $scope.certificateProcessType.name,
                        organizationalUnitId: $scope.employeeFile.organizationalUnitId,
                        legajoId: $scope.employeeFile.id
                    };

                    return processService.createCertificate(params).then(function () {
                        errors.showSuccess('CreateCertificateSucces');
                        return true;
                    }, showError);
                };

                $scope.saveCertificate = function (resultExistingCertificate) {
                    if (angular.isNumber(resultExistingCertificate)) {
                        var userIdMetadata = $filter('filter')($scope.employeeFile.metadatas, { metadataSystemName: $scope.userIdSystemName }, true);
                        var cuilMetadata = $filter('filter')($scope.employeeFile.metadatas, { metadataSystemName: $scope.cuilSystemName }, true);

                        var certificateAux = {
                            userId: userIdMetadata.length > 0 ? userIdMetadata[0].metadataValue : undefined,
                            type: 0, //empleado
                            providerId: resultExistingCertificate,
                            revocationPin: '',
                            cuil: cuilMetadata.length > 0 ? cuilMetadata[0].metadataValue : undefined
                        };

                        return profileCertificateService.upload(certificateAux, undefined).then(function () {
                            errors.showSuccess('ProfileCertificateUploadedSuccessfully');
                        }, function (error) {
                            errors.showError(error);
                            });
                    } else if (resultExistingCertificate.status) {
                        errors.showError(resultExistingCertificate);
                    }

                    return false;
                };

                $scope.checkExistingCertificate = function (provider) {
                    var userIdMetadata = $filter('filter')($scope.employeeFile.metadatas, { metadataSystemName: $scope.userIdSystemName }, true);
                    var cuilMetadata = $filter('filter')($scope.employeeFile.metadatas, { metadataSystemName: $scope.cuilSystemName }, true);

                    var filters = {
                        userId: userIdMetadata.length > 0 ? userIdMetadata[0].metadataValue : undefined,
                        certificateTypeId: 0, //empleado
                        certificateProviderId: provider.id,
                        cuil: cuilMetadata.length > 0 ? cuilMetadata[0].metadataValue : undefined
                    };

                    return certificateService.get(filters).then(function (result) {
                        $scope.existingCertificate = result;
                        return result;
                    }, function (error) {
                        if (error.data && error.data.modelState && error.data.modelState.nocert) {
                            return provider.id;
                        }

                        return error;
                    });
                };

                var showError = function (error) {
                    errors.showError(error);
                    $window.history.back();
                };

                $scope.load();
            }
        ]);
})();